// Popup.jsx
import React from 'react';
import Draggable from 'react-draggable';

const Popup = ({ children, onClose }: any) => {
  return (
    <Draggable handle=".draggable-handle">
      <div className="modal-overlay fixed inset-0 flex items-center justify-center">
        <div
          className="relative bg-white border shadow-lg w-auto max-w-[90%] max-h-[90%] flex flex-col"
        >
          {/* Fixed header */}
          <div className="sticky top-0 w-full min-h-8 h-8 bg-gray-800 cursor-move draggable-handle flex items-center">
            <button
              className="absolute right-4 text-xl text-gray-500 hover:text-white"
              onClick={onClose}
            >
              &times;
            </button>
          </div>

          {/* Scrollable content */}
          <div
            className="overflow-y-auto p-6 flex-1"
            style={{ maxHeight: "calc(90% - 2rem)" }}
          >
            {children}
          </div>
        </div>
      </div>
    </Draggable>
  );
};



// const Popup = ({ children, onClose }) => {
//   return (
//     <Draggable>
//       <div className="fixed top-10 left-0 w-full h-full flex items-center justify-center z-50">          
//         <div className="relative bg-white border shadow-lg overflow-y-auto">    
//             <div className='w-full h-8 bg-gray-800 cursor-move'>
//                 <button
//                     className="absolute top-0 right-4 text-xl text-gray-500 hover:text-white"
//                     onClick={onClose}
//                 >
//                     &times;
//                 </button>
//             </div>
//             <div className='p-6 '>
//                 {children}
//             </div>          
//         </div>
//       </div>
//     </Draggable>
//   );
// };

export default Popup;
